import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from '@totalsoft/change-tracking-react';
import { IconButton } from '@totalsoft/rocket-ui';
import { Checkbox } from '@mui/material';
import FlexBox from 'components/common/FlexBox';
import { useTranslation } from 'react-i18next';
import { StyledTableBodyCell, StyledTableRow } from 'components/common/Styles';
import PropertySelector from 'features/common/components/property-selector/PropertySelector';

const PropertyComponent = ({ key, lens, properties, validation, disabled, onChangeProperty, onEdit, onDelete, onCancelAdd }) => {
  const [t] = useTranslation();

  return (
    <Fragment>
      <StyledTableRow hover key={key}>
        {lens.editing |> get ? (
          <Fragment>
            <PropertySelector
              required
              lens={lens}
              properties={properties}
              validation={validation}
              disabled={disabled}
              valueField='defaultValue'
              // just call onChangeProperty to mark the partnerType;
              // PropertySelector handles the actual property changes, in most cases custom handling isn't needed
              onChange={_ => onChangeProperty()}
              container={StyledTableBodyCell}
            />
            <StyledTableBodyCell>
              <Checkbox
                checked={get(lens.mandatory) || false}
                onChange={value => onChangeProperty('mandatory', value.target.checked, lens)}
                disabled={disabled}
              />
            </StyledTableBodyCell>
            <StyledTableBodyCell>
              <FlexBox gap={1} alignItems='center' justifyContent='end'>
                <IconButton
                  size='small'
                  type='cancel'
                  variant='text'
                  color='primary'
                  onClick={() => onCancelAdd()}
                  tooltip={t('Cancel')}
                  disabled={disabled}
                />
              </FlexBox>
            </StyledTableBodyCell>
          </Fragment>
        ) : (
          <Fragment>
            <StyledTableBodyCell>{get(lens.propertyName)}</StyledTableBodyCell>
            <StyledTableBodyCell>{get(lens.defaultValue)}</StyledTableBodyCell>
            <StyledTableBodyCell>
              <Checkbox checked={get(lens.mandatory)} disabled />
            </StyledTableBodyCell>
            <StyledTableBodyCell>
              <FlexBox gap={1} alignItems='center' justifyContent='end'>
                <IconButton
                  size='small'
                  type='edit'
                  variant='text'
                  color='primary'
                  onClick={() => onEdit(get(lens.propertyId))}
                  tooltip={t('Edit')}
                  disabled={disabled}
                />
                <IconButton
                  size='small'
                  type='delete'
                  variant='text'
                  color='primary'
                  onClick={() => onDelete(get(lens.propertyId))}
                  tooltip={t('Delete')}
                  disabled={disabled}
                />
              </FlexBox>
            </StyledTableBodyCell>
          </Fragment>
        )}
      </StyledTableRow>
    </Fragment>
  );
};

PropertyComponent.propTypes = {
  key: PropTypes.number,
  lens: PropTypes.object.isRequired,
  properties: PropTypes.array,
  disabled: PropTypes.bool.isRequired,
  validation: PropTypes.object.isRequired,
  onChangeProperty: PropTypes.func,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCancelAdd: PropTypes.func.isRequired
};
export default PropertyComponent;
